import React from "react";
import "./Division.scss";

const Division = () => {
  return (
    <section className="division-homepage">
      <div className="division-homepage-wrapper">
        <div className="division-text-homepage">
          <h1>Divisi yang ada di Kirmago</h1>
          <p>Beberapa Divisi Kirmago Yang Kalian Bisa Ikuti Sesuka Hati</p>
        </div>
        <div className="division-box-homepage-wrapper">
          <div className="division-box-homepage">
            <img
              className="flat-kti1"
              src="https://telegra.ph/file/54ee9fe6358e63a0f0c88.png"
              alt="source"
            />
            <img
              src="https://telegra.ph/file/60d5e5649d43412336f4b.png"
              alt="source"
            />
            <h3>Karya Tulis Ilmiah</h3>
            <button>Detail</button>
            <button>Daftar KTI</button>
          </div>
          <div className="division-box-homepage">
            <img
              className="flat-pgr1"
              src="https://telegra.ph/file/688f19e7c5fcd136472d5.png"
              alt="source"
            />
            <img
              src="https://telegra.ph/file/8af6e3e09332f43e58b83.png"
              alt="source"
            />
            <h3>Pemrograman (Developing)</h3>
            <button>Detail</button>
            <button>Daftar PGR</button>
          </div>
          <div className="division-box-homepage">
            <img
              className="flat-mm1"
              src="https://telegra.ph/file/1e86b8c6a08c0950732db.png"
              alt="source"
            />
            <img
              src="https://telegra.ph/file/3d147634e0d6dde55e075.png"
              alt="source"
            />
            <h3>Multimedia</h3>
            <button>Detail</button>
            <button>Daftar MM</button>
          </div>
        </div>
        <div className="division-text-expl-homepage">
          <p>
            Ekskul Kirmago menawarkan berbagai divisi yang masing-masing
            memiliki manfaat dan keuntungan tersendiri. Setiap divisi dirancang
            untuk mengembangkan keterampilan khusus, memperkaya pengalaman
            belajar, dan membuka peluang baru bagi para anggotanya. Dengan
            bergabung dalam ekskul ini, anggota tidak hanya memperoleh
            pengetahuan dan keterampilan baru, tetapi juga berkesempatan untuk
            berkolaborasi dengan rekan-rekan yang memiliki minat yang sama,
            memperluas jaringan pertemanan, dan mempersiapkan diri untuk
            berbagai tantangan di masa depan.
          </p>
        </div>
      </div>

      <div className="division-read-homepage">
        <img
          className="jawir-membaca"
          src="https://telegra.ph/file/b07693e01a6645a0218f8.png"
          alt="source"
        />
        <img
          className="jawir-membaca"
          src="https://telegra.ph/file/89354f1dbce18de1ecdad.png"
          alt="source"
        />
      </div>
    </section>
  );
};

export default Division;
